import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { DropdownContent } from '../../../../../infra/ui/dropdown';
export var DropdownList = function (_a) {
    var children = _a.children, className = _a.className, contentClassName = _a.contentClassName;
    return (_jsx(DropdownContent, { sideOffset: 12, align: "end", className: contentClassName, children: _jsx("div", { className: "".concat(styles['list-container'], " ").concat(className || ''), children: children }) }));
};
